import NuevoContrato from "@/store/modules/Contratos/NuevoContrato/NuevoContrato";
import BajaContrato from "@/store/modules/Contratos/BajaContrato/BajaContrato";
import Mantenimiento from "@/store/modules/Contratos/Mantenimiento/Mantenimiento";
import ModificarContrato from "./ModificarContrato/ModificarContrato";
import { get } from "lodash-es";
import axios from "axios";

export default {
  modules: {
    NuevoContrato: {
      ...NuevoContrato,
    },
    BajaContrato: {
      ...BajaContrato,
    },
    Mantenimiento: {
      ...Mantenimiento,
    },
    ModificarContrato: {
      ...ModificarContrato,
    },
  },
  state: () => ({
    contratos: [],
    contratoForUpdate: null,
    clienteId: null,
    nombreWeb: null,
  }),
  mutations: {
    setContratos(state, payload) {
      state.contratos = payload;
    },
    setContratoForUpdate(state, payload) {
      state.contratoForUpdate = payload;
    },
    setNombreWeb(state, payload) {
      state.nombreWeb = payload;
    },
  },
  actions: {
    async getContratos(context, payload) {
      const resp = await axios.post("/execute", {
        method: "CLI.GetContratosByClienteId",
        parameters: [{ name: "id_cliente", value: payload }],
      });
      if (resp.data.ok) {
        const contratos = get(resp, "data.result[0]", []);
        context.commit("setContratos", contratos);
      } else {
        return resp.data; //
      }
    },
    async getNombreWeb(context, payload) {
      const resp = await axios.post("/execute", {
        method: "CLI.GetClienteSimpleById",
        parameters: [{ name: "id_cliente", value: payload }],
      });
      if (resp.data.ok) {
        context.commit(
          "setNombreWeb",
          get(resp, "data.result[0][0].nombre_web", "no hay nombre"),
        );
      }
      return resp.data;
    },
  },
  getters: {
    getContratos(state) {
      return state.contratos;
    },
  },
};
